// extracted by mini-css-extract-plugin
export default {"root":"nAt4No","button":"cCn70z","avatar":"WTGBrW","arrow":"wD84sc","arrowStateOpen":"RiVrzF","dropdownOuter":"GyuGE6","dropdownOpened":"mDTr_2","list":"GtD9EY"};